import { CheckBox } from '@design/components/checkbox/CheckBox';
import { highlight } from '@helpers';
import { FlagIcon } from '@terminal/components/flag-icon/FlagIcon';
import clsx from 'clsx';

import styles from './FollowCountryRow.module.scss';

export interface FollowCountryRowProps {
  countryCode: string;
  countryName: string;
  isSelected: boolean;
  onToggle: () => void;
  indented?: boolean;
  highlighted?: string;
}

/**
 * @deprecated
 */
export const FollowCountryRow = ({
  countryCode,
  countryName,
  isSelected,
  onToggle,
  indented = false,
  highlighted,
}: FollowCountryRowProps) => {
  const displayName = highlighted
    ? highlight(countryName, highlighted)
    : countryName;

  return (
    <div
      className={clsx(styles.row, { [styles.indented]: indented })}
      data-testid={`follow-country-row-${countryCode}`}
    >
      <CheckBox
        className={styles.checkbox}
        name={countryCode}
        label={
          <span className={styles.details}>
            <FlagIcon
              countryCode={countryCode}
              variant="circular"
              customSize={32}
            />
            <span className={styles.title}>{displayName}</span>
          </span>
        }
        checked={isSelected}
        onChange={onToggle}
      />
    </div>
  );
};
